import { formatDateString } from "@cp/toolkit";
import type { BankanMarketingPlanColumnQuery } from "@qw/graphql";
import { BankanCard } from "./bankan-card";

type Group = BankanMarketingPlanColumnQuery["bankanMarketingPlanColumn"]["groupedMarketingPlans"][number];

export const BankanCardOpportunities = ({
  insured,
  opportunities,
  slice = 1,
}: {
  insured: Group["insured"];
  opportunities: Group["marketingPlans"];
  slice?: number;
}) => {
  const items = opportunities.slice(0, slice);
  const remaining = Math.max(opportunities.length - slice, 0);
  return (
    <BankanCard id={insured.id} name={insured.name} remaining={remaining}>
      {items.map((opportunity) => (
        <div
          key={opportunity.id}
          className="bg-card px-3 py-2 first-of-type:rounded-t last-of-type:rounded-b space-y-1"
        >
          <div className="font-medium text-xs truncate">{opportunity.selectedLinesOfBusiness.join(", ")}</div>
          <div className="text-2xs text-muted-foreground">{formatDateString(opportunity.desiredEffectiveDate)}</div>
        </div>
      ))}
    </BankanCard>
  );
};
